import { useState, useEffect } from 'react';
import moment from 'moment';

import { ENTITY_STATISTIC_FILTER_TYPES, HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

import styles from './EntityStatistics.module.css';
import AuthStatistics from '../../../AuthStatistics/AuthStatistics';
import { httpGet } from '../../../utils';
import { Dropdown } from '@silverfort/sf-components';

const EntityStatistics = ({ entityGuid, entityId, entityType }) => {
    const [activityByProtocol, setActivityByProtocol] = useState([]);
    const [protocolUsage, setProtocolUsage] = useState([]);
    const [usageByProtocol, setUsageByProtocol] = useState({});
    const [totalAuths, setTotalAuths] = useState(0);
    const [daysFilter, setDaysFilter] = useState('7');

    useEffect(() => {
        const getEntityStatistics = async () => {
            const filterStartDate = moment().subtract(Number(daysFilter), 'd');
            const filterEndDate = moment();
            const filters = {
                [ENTITY_STATISTIC_FILTER_TYPES.TIME]: {
                    UTCStartDate: moment.utc(filterStartDate).unix(),
                    UTCEndDate: moment.utc(filterEndDate).unix()
                }
            };
            const params = {
                entityGuid: entityGuid,
                entityId: entityId,
                entityType: entityType.id,
                filters: filters
            };
            const response = await httpGet('/investigate/statistic', {
                [HTTP_OPTIONS.REQ_OPTIONS]: { params: params }
            });
            const statistics = response.data;

            if (statistics.activityByProtocol) {
                setActivityByProtocol(statistics.activityByProtocol);
            }

            const tempUsageByProtocol = {};
            let tempTotalAuths = 0;
            if (statistics.protocol_usages) {
                setProtocolUsage(statistics.protocol_usages);
                for (const usageData of statistics.protocol_usages) {
                    tempUsageByProtocol[usageData.protocol_type.toUpperCase()] = usageData.count;
                    tempTotalAuths += usageData.count;
                }
            }
            setTotalAuths(tempTotalAuths);
            setUsageByProtocol(tempUsageByProtocol);
        };
        if (entityId !== null) {
            getEntityStatistics();
        }
    }, [entityGuid, entityId, entityType, daysFilter]);

    return (
        <AuthStatistics
            activityByProtocol={activityByProtocol}
            protocolUsage={protocolUsage}
            totalAuths={totalAuths}
            usageByProtocol={usageByProtocol}
            topLeftSelectComponent={
                <div className={styles.selectWarper}>
                    <Dropdown
                        className={`w-[120px] [&&]:bg-[#212a30] text-sf-white border-b border-sf-gray-500 hover:bg-sf-gray-600`}
                        items={[
                            { value: '1', title: '24 hours' },
                            { value: '7', title: '7 days' },
                            { value: '30', title: '30 days' }
                        ]}
                        fullMenuWidth={120}
                        selectedItems={daysFilter}
                        variant="trigger"
                        onChange={(value) => {
                            setDaysFilter(value);
                        }}
                    />
                </div>
            }
            daysFilter={Number(daysFilter)}
        />
    );
};

export default EntityStatistics;
